//LIBRARIES
import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import EditIcon from '@material-ui/icons/Edit';

//HELPERS
import { getTranslatedString } from 'helpers/i18n';
import { padDetailsTypes } from 'helpers/constants';
import { formatMoney } from 'helpers/Formatter';
import { AccentColor } from 'helpers/AccentColorHelper';

// COMPONENTS
import { RenderIfToggleOn } from 'components/shared/ToggleRenderer';

const AutoPayActiveDetails = ({
  isSplitPay,
  autoPayMonthlyValue,
  padDetails,
  processFee,
  modifyPadDetails,
  modifyPaymentAmount,
}) => {
  return (
    <React.Fragment>
      {isSplitPay && (
        <div className="row" style={{ textAlign: 'center' }}>
          <p>
            <div>{getTranslatedString('autopay.monthlyBalanceLabel')}</div>
            {autoPayMonthlyValue()}
          </p>
          {parseFloat(processFee) > 0 && (
            <p>
              <div>{getTranslatedString('autopay.debitProcessingFeesLabel')}</div>
              {formatMoney(processFee)}
            </p>
          )}
        </div>
      )}

      {padDetails?.payment_type === padDetailsTypes.EFT ? (
        <EFTDetails
          padDetails={padDetails}
          modifyPaymentAmount={modifyPaymentAmount}
          modifyPadDetails={modifyPadDetails}
        />
      ) : (
        <ACHDetails
          padDetails={padDetails}
          modifyPaymentAmount={modifyPaymentAmount}
          modifyPadDetails={modifyPadDetails}
        />
      )}
    </React.Fragment>
  );
};

const ModifyButtons = ({ modifyPaymentAmount, modifyPadDetails }) => (
  <div style={{ display: 'inline-grid' }}>
    <FlatButton
      labelStyle={{ textTransform: 'capitalize' }}
      icon={<EditIcon style={{ fontSize: '16px' }} />}
      label={getTranslatedString('autopay.modifyAutopayDetails')}
      onClick={() => modifyPadDetails()}
      style={{ color: AccentColor(), marginTop: '10px' }}
    />
    <RenderIfToggleOn toggle="splitpay">
      <FlatButton
        labelStyle={{ textTransform: 'capitalize' }}
        icon={<EditIcon style={{ fontSize: '16px' }} />}
        label={getTranslatedString('autopay.modifyMonthlyAmountLabel')}
        onClick={() => modifyPaymentAmount()}
        style={{ color: AccentColor(), marginTop: '10px' }}
      />
    </RenderIfToggleOn>
  </div>
);

const EFTDetails = ({ padDetails, modifyPaymentAmount, modifyPadDetails }) => (
  <div className="row" style={{ textAlign: 'center' }}>
    <p>
      <div>{getTranslatedString('autopay.transitBranchNumber')}</div>
      {padDetails.transit_number}
    </p>
    <p>
      <div>{getTranslatedString('autopay.institutionNumber')}</div>
      {padDetails.institution_number}
    </p>
    <p>
      <div>{getTranslatedString('autopay.accountNumber')}</div>
      {padDetails.account_number}
    </p>
    {padDetails.has_signed_pad_agreement && (
      <ModifyButtons
        modifyPaymentAmount={modifyPaymentAmount}
        modifyPadDetails={modifyPadDetails}
      />
    )}
  </div>
);

const ACHDetails = ({ padDetails, modifyPaymentAmount, modifyPadDetails }) => (
  <div className="row" style={{ textAlign: 'center' }}>
    <p>
      <div>{getTranslatedString('autopay.routingNumber')}</div>
      {padDetails.routing_number}
    </p>
    <p>
      <div>{getTranslatedString('autopay.accountNumber')}</div>
      {padDetails.account_number}
    </p>
    <p>
      <div>{getTranslatedString('autopay.accountType')}</div>
      {padDetails.ach_account_type}
    </p>
    {padDetails.has_signed_pad_agreement && (
      <ModifyButtons
        modifyPaymentAmount={modifyPaymentAmount}
        modifyPadDetails={modifyPadDetails}
      />
    )}
  </div>
);

export default AutoPayActiveDetails;
